import * as React from 'react';
import { ViewContainer } from '../ViewContainer';
import { TitleContainer } from '../TitleContainer';
import { SocialsContainer } from '../SocialsContainer';
import { FormContainer } from './containers/FormContainer';
import { trackLoginNeedHelp } from '../../utils/tracking';
import { NoticeContainer } from '../NoticeContainer';
import { HelpContainer } from '../HelpContainer';
import { PromoBannerContainer } from '../PromoBannerContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function UsernameAuthView(_ref) {
  var source = _ref.source;
  var handleHelpClick = React.useCallback(function () {
    return trackLoginNeedHelp(source);
  }, [source]);
  return /*#__PURE__*/_jsxs(ViewContainer, {
    children: [/*#__PURE__*/_jsx(TitleContainer, {}), /*#__PURE__*/_jsx(NoticeContainer, {}), /*#__PURE__*/_jsx(FormContainer, {}), /*#__PURE__*/_jsx(SocialsContainer, {}), /*#__PURE__*/_jsx(HelpContainer, {
      onClick: handleHelpClick
    }), /*#__PURE__*/_jsx(PromoBannerContainer, {})]
  });
}